var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01758 14.5263V1.78571C1.01758 1.61676 1.08469 1.45473 1.20416 1.33526C1.32363 1.2158 1.48566 1.14868 1.65461 1.14868H15.6693C15.8382 1.14868 16.0002 1.2158 16.1197 1.33526C16.2392 1.45473 16.3063 1.61676 16.3063 1.78571V14.5263L13.7582 13.2522L11.21 14.5263L8.66193 13.2522L6.11381 14.5263L3.5657 13.2522L1.01758 14.5263Z",
    stroke: "#727D9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20117 10.0672L6.74929 4.97095L9.29741 10.0672",
    stroke: "#727D9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83984 8.79297H8.66202",
    stroke: "#727D9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5723 7.51904H13.7574",
    stroke: "#727D9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1641 5.92651V9.11166",
    stroke: "#727D9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile4);
export default __webpack_public_path__ + "static/media/profile4.1be60fdacebed358eb053ca7d886bef0.svg";
export { ForwardRef as ReactComponent };